module.exports = __webpack_public_path__ + "static/media/lot_low.f617c466.svg";